const state = {
    deliveryNoteLijst: [],
    deliveryNoteLijstPrinted: [],
    printOptionsLijst: [],
    selectedDeliveryNote: null,
    ownCompany: null
};

export default state;
